import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_INTERFACE} from '../../metamodel/Concept';

export default class ApplicationInterfaceNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_INTERFACE;
	}
}
